
<template>
  <div class="container">
    <header class="page-header">
      <h3 class="widget-title">Search Result</h3>
      <ol class="breadcrumb page-breadcrumb">
        <li>
          <router-link :to="{ name: 'home'}">Home</router-link>
        </li>
        <li>
          <a href="#">Search</a>
        </li>
      </ol>
    </header>
    <div class="row">
      <div class="tabbable product-tabs">
        <ul class="nav nav-tabs-search" id="myTab">
          <li @click="activateProducts" class="active">
            <a href="#tab-1" data-toggle="tab">Products {{$route.query.keyword != '' ? '('+searchCount.TotalProduct+')' : ''}}</a>
          </li>
          <li @click="activateServices">
            <a href="#tab-2" data-toggle="tab">Services {{$route.query.keyword != '' ? '('+searchCount.TotalService+')' : ''}}</a>
          </li>
          <li @click="activateCompany">
            <a href="#tab-3" data-toggle="tab">Company {{$route.query.keyword != '' ? '('+searchCount.TotalCompany+')' : ''}}</a>
          </li>
        </ul>
      </div>
      <div class="col-md-9">
        <div
          v-if="searchList.searchList != null && searchList.searchList.length > 0"
          class="row"
          data-gutter="15"
          v-for="result in searchList.searchList"
        >
          <div class="col-md-12">
            <div class="product product-left">
              <div class="product-img-wrap">
                <img
                  class="product-img-primary"
                  v-bind:src="result.ItemImage"
                  alt="Image Alternative text"
                  title="Image Title"
                />
                <img
                  class="product-img-alt"
                  v-bind:src="result.ItemImageAlt != '' ? result.ItemImageAlt : result.ItemImage"
                  alt="Image Alternative text"
                  title="Image Title"
                />
              </div>
              <div class="product-caption-search">
                <h5 class="product-caption-title-search"  >
                  <router-link
                    v-if="searchType == 'PRODUCTS'"
                    :to="{ name: 'product', params: { id: result.Id }}"
                  >
                  {{result.Name}}                   
                  </router-link>
                  <router-link
                    v-if="searchType == 'SERVICES'"
                    :to="{ name: 'service', params: { id: result.Id }}"
                  >{{result.Name}}</router-link>
                  <router-link
                    target="_blank"
                    v-if="searchType == 'COMPANY'"
                    :to="{ name: 'company', params: { id: result.Id }}"
                  >{{result.CompanyName}}</router-link>
                </h5>
                <div
                  class="product-caption-price"
                  v-if="searchType == 'PRODUCTS'|| searchType == 'SERVICES' "
                >
                  <span class="product-caption-price-search">Category : {{result.Category}}</span>
                </div>
                <ul
                  class="product-caption-feature-list-title"
                  v-if="searchType == 'PRODUCTS'|| searchType == 'SERVICES' "
                >
                  <li>{{result.ShortDescription}}</li>
                </ul>
              </div>
              <div class="product-caption-search-co">
                <h5
                  class="product-caption-title-search-co"
                  v-if="searchType == 'PRODUCTS'|| searchType == 'SERVICES' "
                >
                  <router-link
                    target="_blank"
                    :to="{ name: 'company', params: { id: result.CompanyId }}"
                  >{{result.CompanyName}}</router-link>
                </h5>
                <ul class="product-caption-feature-list-title">
                  <li>{{result.Location}}</li>
                </ul>
              </div>
            </div>
          </div>
          <!-- {{result}}-->
        </div>
        <!-- <span v-if="results == null || results.length == 0">There are no item as per your search request. Please try again</span>
                    <div class="row" v-if="results != null && results.length > 0">
                        <div class="col-md-6"></div>
                        <div class="col-md-6">
                            <nav>
                                <ul class="pagination category-pagination pull-right">
                                    <li class="active"><a href="#">1</a>
                                    </li>
                                    <li><a href="#">2</a>
                                    </li>
                                    <li><a href="#">3</a>
                                    </li>
                                    <li><a href="#">4</a>
                                    </li>
                                    <li><a href="#">5</a>
                                    </li>
                                    <li class="last"><a href="#"><i class="fa fa-long-arrow-right"></i></a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
        </div>-->
      </div>
      <LatestTendersRfq></LatestTendersRfq>
    </div>
    <div class="card-footer pb-0 pt-3" v-if="rowsItemList>0">
      <paginate
        :pageCount="totalPageItemList"
        :containerClass="'pagination'"
        :clickHandler="onChangePageItemList"
        :forcePage="pageOfItems"
      ></paginate>
    </div>
    <p class="mt-3">Total Records: {{ rowsItemList }}</p>
    <!--<div class="overflow-auto">
                  <b-pagination
                          v-model="currentPage"
                          :total-rows="rows"
                          :per-page="perPage"
                          first-text="First"
                          prev-text="Prev"
                          next-text="Next"
                          last-text="Last"
                  ></b-pagination>

                  <p class="mt-3">Current Page: {{ currentPage }}</p>

                  <b-table
                          id="my-table"
                          :items="results"
                          :per-page="perPage"
                          :current-page="currentPage"
                          small
                  ></b-table>
    </div>-->
  </div>
</template>

<script>
import Vue from "vue";
import LatestTendersRfq from "@/components/LatestTendersRfq";
import { mapState } from "vuex";
import Paginate from "vuejs-paginate";
Vue.component("paginate", Paginate);
// import { BPagination, BTable } from 'bootstrap-vue'

export default {
  data() {
    return {
      searchType: "PRODUCTS",
      pageOfItems: 1
    };
  },
  //  data() {
  //     return {
  //         searchType: 'Products',
  //         RowsPerPage: '10',
  //         PageNumber: '1',
  //         /*perPage: 3,
  //         currentPage: 1,
  //         items: [
  //             { id: 1, first_name: 'Fred', last_name: 'Flintstone' },
  //             { id: 2, first_name: 'Wilma', last_name: 'Flintstone' },
  //             { id: 3, first_name: 'Barney', last_name: 'Rubble' },
  //             { id: 4, first_name: 'Betty', last_name: 'Rubble' },
  //             { id: 5, first_name: 'Pebbles', last_name: 'Flintstone' },
  //             { id: 6, first_name: 'Bamm Bamm', last_name: 'Rubble' },
  //             { id: 7, first_name: 'The Great', last_name: 'Gazzoo' },
  //             { id: 8, first_name: 'Rockhead', last_name: 'Slate' },
  //             { id: 9, first_name: 'Pearl', last_name: 'Slaghoople' }
  //         ]*/
  //     };
  // },
  components: {
    LatestTendersRfq
    //BPagination,
    // BTable
  },
  created() {
    // this.$store.dispatch('search/search', { keyword: this.$route.query.keyword, itemType: this.searchType })
    // this.$store.dispatch("search/search", {
    //   keyword: this.$route.query.keyword,
    //   itemType: "PRODUCTS",
    //   RowsPerPage: 10,
    //   PageNumber: 1
    // });
    this.initViewItemList();
    this.itemCount();
    //console.log('this.searchCount :::::::::::::: ', this.searchCount);
  },
  computed: {
    // ...mapState("search", ["results"]),
    ...mapState({
      //company: state => state.company.companyDetails,
      searchList: state => state.search.searchList,
      searchCount: state => state.search.searchCount
      //serviceList: state => state.company.companyServiceList
    }),
    //   rows() {
    //     return this.items.length
    //   }
    totalPageItemList() {
      return this.searchList.searchListRowCount == 0
        ? 0
        : Math.trunc(this.searchList.searchListRowCount / 10) +
            (this.searchList.searchListRowCount % 10 > 0 ? 1 : 0);
      //return 5;
    },
    rowsItemList() {
      return this.searchList.searchListRowCount;
      //return 10;
    }
  },
  methods: {    
    activateProducts() {
      this.searchType = "PRODUCTS";
      this.pageOfItems = 1;
      // this.$store.dispatch('search/search', { keyword: this.$route.query.keyword, itemType: this.searchType })
      //   this.$store.dispatch("search/search", {
      //     keyword: this.$route.query.keyword,
      //     itemType: this.searchType,
      //     RowsPerPage: this.RowsPerPage,
      //     PageNumber: this.PageNumber
      //   });
      this.initViewItemList();
    },
    activateServices() {
      this.searchType = "SERVICES";
      this.pageOfItems = 1;
      // this.$store.dispatch('search/search', { keyword: this.$route.query.keyword, itemType: this.searchType })
      //   this.$store.dispatch("search/search", {
      //     keyword: this.$route.query.keyword,
      //     itemType: this.searchType,
      //     RowsPerPage: this.RowsPerPage,
      //     PageNumber: this.PageNumber
      //   });
      this.initViewItemList();
    },
    activateCompany() {
      this.searchType = "COMPANY";
      this.pageOfItems = 1;
      //   this.$store.dispatch("search/search", {
      //     keyword: this.$route.query.keyword,
      //     itemType: this.searchType
      //   });
      this.initViewItemList();
    },

    initViewItemList() {
      this.$store.dispatch("search/search", {
        keyword: this.$route.query.keyword,
        itemType: this.searchType,
        RowsPerPage: 10,
        PageNumber: this.pageOfItems
      });
    },

    itemCount() {
      this.$store.dispatch("search/searchCount", {
        keyword: this.$route.query.keyword
      });
    },

    onChangePageItemList(pageOfItems) {
      this.pageOfItems = pageOfItems;
      this.initViewItemList(this.pageOfItems);
      //this.initViewServiceList(this.$route.params.id, this.pageOfItemsService);
    }
  },
  watch: {
    $route(to, from) {
      this.initViewItemList(this.pageOfItems);
      this.itemCount();
    }
  }
  //   watch: {
  //     $route(to, from) {
  //       //console.log('WATCHHHHH');
  //       //this.$store.dispatch('search/search', { keyword: this.$route.query.keyword, itemType: this.searchType })
  //       this.$store.dispatch("search/search", {
  //         keyword: this.$route.query.keyword,
  //         itemType: this.searchType,
  //         RowsPerPage: this.RowsPerPage,
  //         PageNumber: this.PageNumber
  //       });
  //     }
  //   }
};
</script>
<style scoped>
.highlight {
  background-color: yellow;
}
</style>